import { IFalconTheme } from '@se-admin/falcon';
import { IBooking } from '../../common/types/apiSchema';

export interface IBookingCardListProps {
  bookings: IBooking[];
  variant: BookingCardListVariant;
  theme?: IFalconTheme;
}

export enum BookingCardListVariant {
  UPCOMING = 'upcoming',
  PAST = 'past',
  CANCELLED = 'cancelled',
}
